

















































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountDuplicate } from '@/shared/clients/client-account-duplicate';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

@Component
export default class PotentialDuplicateDetails extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;
    @typesModule.Getter('clientStatusTypes') private clientStatusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;

    @Prop({ required: true }) private client!: ClientAccount;
    @Prop({ required: true }) private duplicateAccounts!: Array<ClientAccountDuplicate>;

    private originalClient: ClientAccount = { ...this.client };

    private clientStatusTypeDescription(duplicate: ClientAccountDuplicate): string {
        const clientStatusType = this.clientStatusTypes.find((type) => type.id === duplicate.accountStatusId);
        return clientStatusType == null ? '' : clientStatusType.value;
    }

    private clientOriginalSourceTypeDescription(duplicate: ClientAccountDuplicate): string {
        const clientOriginalSourceType = this.clientOriginalSourceTypes.find((type) => type.id === duplicate.originalSourceId);
        return clientOriginalSourceType == null ? '' : clientOriginalSourceType.value;
    }

    private onMerge(duplicate: ClientAccountDuplicate): void {
        this.client.id = duplicate.id!;
    }

    private onCancelMerge(): void {
        this.client.id = null;
    }
}
